import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import CalculationItemHeader from './CalculationItemHeader';
import CalculationItemRanges from './CalculationItemRanges';
import CalculationItemOptions from './CalculationItemOptions';
import CalculationItemExcess from './CalculationItemExcess';

function CalculationInformation({ permitId, initialFeeId, data }) {
  return (
    <>
      {data.map(item => {
        return (
          <div className="border rounded mb-3">
            {get(item, 'attributes.description') ? (
              <b className="text-primary px-1 py-2">
                {get(item, 'attributes.description') || ''}
              </b>
            ) : null}
            <CalculationItemHeader
              permitId={permitId}
              initialFeeId={initialFeeId}
              data={item}
            />
            <CalculationItemRanges
              data={get(item, 'included.sourceDetails', [])}
            />
            <CalculationItemOptions
              data={get(item, 'included.sourceDetails', [])}
            />
            <CalculationItemExcess data={get(item, 'included.source', {})} />
          </div>
        );
      })}
    </>
  );
}

CalculationInformation.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  permitId: PropTypes.number.isRequired,
  initialFeeId: PropTypes.number.isRequired,
};

export default CalculationInformation;
